import { useCallback } from 'react';
import { useQueryClient } from 'react-query';
import { CareCreditIntegrationV1 } from '@frontend/api-care-credit-integration';

export type UseCareCreditDisconnectProviderProps = {
  locationId: string | undefined;
};

export const useCareCreditDisconnectProvider = ({ locationId }: UseCareCreditDisconnectProviderProps) => {
  const queryClient = useQueryClient();

  const { queryKey } = CareCreditIntegrationV1.Queries.useGetMerchantConnectionQuery({
    request: {
      locationId,
    },
    options: {
      enabled: false,
    },
  });

  const { mutateAsync, isLoading } = CareCreditIntegrationV1.Mutations.useArchiveMerchantConnectionMutation({
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries(queryKey);
      },
    },
  });

  const onDisconnectMutation = useCallback(async (): Promise<void> => {
    await mutateAsync({
      locationId: locationId!,
    });
  }, [mutateAsync, locationId]);

  return { onDisconnectMutation, isMutating: isLoading };
};
